/**
 * Neimien — Theme JavaScript v2.0
 */
(function() {
  'use strict';

  /* ---- Utilities ---- */
  var qs = function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };
  var on = function(el, evt, fn, opts) { el && el.addEventListener(evt, fn, opts); };

  function formatMoney(cents) {
    var fmt = (window.neimien && window.neimien.moneyFormat) || '€{{amount}}';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return fmt
      .replace(/\{\{amount\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount);
  }

  function showToast(message, type) {
    var container = qs('#toastContainer');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'toast' + (type ? ' ' + type : '');
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(function() {
      toast.classList.add('toast-exit');
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }

  /* ---- Header scroll ---- */
  function initHeader() {
    var header = qs('.site-header');
    if (!header) return;
    var onScroll = function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mobile drawer
    var drawerToggle = qs('[data-drawer-toggle]');
    var drawer = qs('[data-drawer]');
    var navOverlay = qs('.mobile-nav-overlay');
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      navOverlay && navOverlay.classList.add('open');
      drawerToggle && drawerToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      navOverlay && navOverlay.classList.remove('open');
      drawerToggle && drawerToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    on(drawerToggle, 'click', function() {
      drawer && drawer.classList.contains('open') ? closeDrawer() : openDrawer();
    });
    on(navOverlay, 'click', closeDrawer);
    on(qs('[data-drawer-close]'), 'click', closeDrawer);
    qsa('.mobile-drawer__nav a').forEach(function(link) {
      on(link, 'click', closeDrawer);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeDrawer();
    });
  }

  /* ---- Cart Drawer ---- */
  function initCartDrawer() {
    var overlay = qs('.cart-drawer-overlay');
    var drawer = qs('.cart-drawer');
    if (!overlay || !drawer) return;

    function open() {
      overlay.classList.add('open');
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('open');
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }

    on(overlay, 'click', close);
    on(qs('.cart-drawer-close', drawer), 'click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });

    // Open on cart icon click
    qsa('[data-cart-toggle]').forEach(function(btn) {
      on(btn, 'click', function(e) {
        e.preventDefault();
        open();
        refreshCart();
      });
    });

    window.neimienCart = { open: open, close: close, refresh: refreshCart };
  }

  function refreshCart() {
    fetch(window.neimien.routes.cart_url + '.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCartDrawer(cart); });
  }

  function renderCartDrawer(cart) {
    var itemsEl = qs('.cart-drawer-items');
    var footerEl = qs('.cart-drawer-footer');
    var countEls = qsa('.cart-count');
    var shippingBar = qs('.shipping-bar');

    // Update count badges
    countEls.forEach(function(el) {
      el.textContent = (cart.item_count != null) ? cart.item_count : '';
    });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg><p>Il tuo carrello è vuoto</p></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = '';

    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_160x160$1') : '';
      html += '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">' : '') + '</div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-title">' + item.product_title + '</div>' +
          '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-item-qty">' +
            '<button data-qty-change="-1" aria-label="Riduci">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-qty-change="1" aria-label="Aumenta">+</button>' +
          '</div>' +
          '<button class="cart-item-remove" data-remove>Rimuovi</button>' +
        '</div></div>';
    });
    itemsEl.innerHTML = html;

    // Subtotal + sconto (prezzo pieno barrato accanto a quello scontato)
    var subtotalEl = qs('.cart-subtotal-amount');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
      subtotalEl.classList.toggle('in-saldo', cart.total_discount > 0);
    }
    var pienoEl = qs('.cart-subtotal-pieno');
    if (pienoEl) {
      pienoEl.textContent = formatMoney(cart.original_total_price);
      pienoEl.hidden = !(cart.total_discount > 0);
    }
    var scontoEl = qs('.cart-sconto');
    if (scontoEl) {
      scontoEl.hidden = !(cart.total_discount > 0);
      var valEl = qs('.cart-sconto__val');
      if (valEl) valEl.textContent = '−' + formatMoney(cart.total_discount);
      // se Shopify dice il nome dello sconto lo usiamo, altrimenti resta "Sconto di benvenuto"
      var app = (cart.cart_level_discount_applications || [])[0];
      var nomeEl = qs('.cart-sconto__nome');
      if (nomeEl && app && app.title) {
        nomeEl.textContent = /benvenut/i.test(app.title) ? 'Sconto di benvenuto' : app.title;
      }
    }

    // Shipping bar
    if (shippingBar) {
      var threshold = (window.neimien.freeShippingThreshold || 49) * 100;
      var total = cart.total_price;
      var pct = Math.min((total / threshold) * 100, 100);
      var fill = qs('.shipping-bar-fill', shippingBar);
      var text = qs('.shipping-bar-text', shippingBar);
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (total >= threshold) {
          text.innerHTML = '🎉 <strong>Spedizione gratuita!</strong>';
        } else {
          var remaining = formatMoney(threshold - total);
          text.innerHTML = 'Aggiungi <strong>' + remaining + '</strong> per la spedizione gratuita';
        }
      }
    }

    // Qty change + remove events
    qsa('[data-qty-change]', itemsEl).forEach(function(btn) {
      on(btn, 'click', function() {
        var item = btn.closest('.cart-item');
        var key = item.dataset.key;
        var delta = parseInt(btn.dataset.qtyChange);
        var current = parseInt(qs('span', btn.parentElement).textContent);
        var newQty = Math.max(0, current + delta);
        updateCartItem(key, newQty);
      });
    });
    qsa('[data-remove]', itemsEl).forEach(function(btn) {
      on(btn, 'click', function() {
        var key = btn.closest('.cart-item').dataset.key;
        updateCartItem(key, 0);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch(window.neimien.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); });
  }

  /* ---- Add to Cart (AJAX) ---- */
  function initAddToCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var btn = qs('[type="submit"]', form);
      var btnText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="spinner"></span>';
      }

      var formData = new FormData(form);
      fetch(window.neimien.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Errore');
        return r.json();
      })
      .then(function() {
        showToast('Aggiunto al carrello!', 'success');
        if (window.neimienCart) {
          window.neimienCart.refresh();
          window.neimienCart.open();
        }
      })
      .catch(function() {
        showToast('Errore nell\'aggiunta al carrello', 'error');
      })
      .finally(function() {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btnText;
        }
      });
    });
  }

  /* ---- Quantity Selector ---- */
  function initQuantity() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.hero-quantity button, .product-qty button');
      if (!btn) return;
      var wrapper = btn.closest('.hero-quantity, .product-qty');
      var input = qs('input', wrapper);
      if (!input) return;
      var val = parseInt(input.value) || 1;
      var min = parseInt(input.min) || 1;
      var max = parseInt(input.max) || 99;
      if (btn.dataset.action === 'decrease' || btn.textContent.trim() === '−') {
        input.value = Math.max(min, val - 1);
      } else {
        input.value = Math.min(max, val + 1);
      }
      input.dispatchEvent(new Event('change'));
    });
  }


  /* Strip any width param then append width=2000 for hi-res lightbox/main */
  function hiResUrl(url) {
    if (!url) return url;
    var clean = url.replace(/([?&])width=\d+/g, '$1').replace(/_\d+x\d+/g, '');
    clean = clean.replace(/\?&/, '?').replace(/&&+/g, '&').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') >= 0 ? '&' : '?') + 'width=2000';
  }

  /* ---- Gallery (hero + product page) ---- */
  function initGallery() {
    qsa('.hero-gallery, .product-gallery').forEach(function(gallery) {
      var mainImg = qs('img', qs('.hero-gallery-main, .product-gallery-main', gallery));
      var thumbs = qsa('.hero-gallery-thumbs button, .product-gallery-thumbs button', gallery);
      if (!mainImg || !thumbs.length) return;
      thumbs.forEach(function(thumb) {
        on(thumb, 'click', function() {
          var thumbImg = qs('img', thumb);
          mainImg.src = hiResUrl(thumbImg.src);
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        });
      });
      if (thumbs[0]) thumbs[0].classList.add('active');
    });
  }

  /* ---- Lightbox ---- */
  function initLightbox() {
    var lightbox = null;
    var images = [];
    var currentIndex = 0;

    function openLightbox(src, allImages) {
      images = allImages || [src];
      currentIndex = images.indexOf(src);
      if (currentIndex < 0) currentIndex = 0;

      if (!lightbox) {
        lightbox = document.createElement('div');
        lightbox.className = 'lightbox';
        lightbox.innerHTML = '<img src="" alt=""><button class="lightbox-close"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button><button class="lightbox-nav lightbox-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button><button class="lightbox-nav lightbox-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></button>';
        document.body.appendChild(lightbox);
        on(qs('.lightbox-close', lightbox), 'click', closeLightbox);
        on(lightbox, 'click', function(e) { if (e.target === lightbox) closeLightbox(); });
        on(qs('.lightbox-prev', lightbox), 'click', function() { navigate(-1); });
        on(qs('.lightbox-next', lightbox), 'click', function() { navigate(1); });
      }

      qs('img', lightbox).src = images[currentIndex];
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (lightbox) lightbox.classList.remove('open');
      document.body.style.overflow = '';
    }

    function navigate(dir) {
      currentIndex = (currentIndex + dir + images.length) % images.length;
      qs('img', lightbox).src = images[currentIndex];
    }

    on(document, 'keydown', function(e) {
      if (!lightbox || !lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    // Click on main gallery image
    on(document, 'click', function(e) {
      var main = e.target.closest('.product-gallery-main, .hero-gallery-main');
      if (!main) return;
      var img = qs('img', main);
      if (!img) return;
      var gallery = main.closest('.product-gallery, .hero-gallery');
      var allImgs = qsa('.product-gallery-thumbs img, .hero-gallery-thumbs img', gallery).map(function(i) {
        return hiResUrl(i.src);
      });
      openLightbox(hiResUrl(img.src), allImgs.length ? allImgs : [hiResUrl(img.src)]);
    });
  }

  /* ---- FAQ Accordion ---- */
  function initFAQ() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.faq-question');
      if (!btn) return;
      var item = btn.closest('.faq-item');
      var answer = qs('.faq-answer', item);
      if (!answer) return;
      var isOpen = item.classList.contains('open');
      // Close all others in same list
      var list = item.closest('.faq-list');
      if (list) {
        qsa('.faq-item.open', list).forEach(function(other) {
          if (other !== item) {
            other.classList.remove('open');
            var a = qs('.faq-answer', other);
            if (a) a.style.maxHeight = null;
          }
        });
      }
      if (isOpen) {
        item.classList.remove('open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  }

  /* ---- Product Accordion ---- */
  function initProductAccordion() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.product-accordion-btn');
      if (!btn) return;
      var item = btn.closest('.product-accordion-item');
      var content = qs('.product-accordion-content', item);
      if (!content) return;
      var isOpen = item.classList.contains('open');
      if (isOpen) {
        item.classList.remove('open');
        content.style.maxHeight = null;
      } else {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  }

  /* ---- Before/After Slider ---- */
  function initBeforeAfter() {
    qsa('.before-after-slider').forEach(function(slider) {
      var handle = qs('.ba-handle', slider);
      var before = qs('.ba-before', slider);
      if (!handle || !before) return;
      var dragging = false;

      function updatePosition(x) {
        var rect = slider.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
        handle.style.left = pct + '%';
        before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      }

      on(slider, 'mousedown', function(e) { dragging = true; updatePosition(e.clientX); });
      on(document, 'mousemove', function(e) { if (dragging) updatePosition(e.clientX); });
      on(document, 'mouseup', function() { dragging = false; });
      on(slider, 'touchstart', function(e) { dragging = true; updatePosition(e.touches[0].clientX); }, { passive: true });
      on(document, 'touchmove', function(e) { if (dragging) updatePosition(e.touches[0].clientX); }, { passive: true });
      on(document, 'touchend', function() { dragging = false; });
    });
  }

  /* ---- Scroll Reveal ---- */
  function initReveal() {
    var els = qsa('.reveal');
    if (!els.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { observer.observe(el); });
  }

  /* ---- Back to Top ---- */
  function initBackToTop() {
    var btn = qs('#backToTop');
    if (!btn) return;
    window.addEventListener('scroll', function() {
      btn.classList.toggle('visible', window.scrollY > 500);
    }, { passive: true });
    on(btn, 'click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- Swiper Init ---- */
  function initSwipers() {
    if (typeof Swiper === 'undefined') return;

    // Announcement bar
    qsa('.announcement-swiper').forEach(function(el) {
      new Swiper(el, {
        direction: 'vertical',
        loop: true,
        autoplay: { delay: 3500, disableOnInteraction: false },
        speed: 600,
        allowTouchMove: false
      });
    });

    // Testimonials
    qsa('.testimonials-swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: { el: '.swiper-pagination', clickable: true },
        breakpoints: {
          769: { slidesPerView: 2, spaceBetween: 24 },
          1025: { slidesPerView: 3, spaceBetween: 30 }
        }
      });
    });

    // Hero slideshow
    qsa('.hero-swiper').forEach(function(el) {
      var section = el.closest('.hero-slideshow');
      new Swiper(el, {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        speed: 800,
        pagination: { el: '.hero-pagination', clickable: true },
        navigation: { prevEl: '.hero-prev', nextEl: '.hero-next' }
      });
    });

    // Product showcase
    qsa('.product-showcase-swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: false,
        pagination: { el: el.querySelector('.showcase-pagination'), clickable: true },
        breakpoints: {
          480: { slidesPerView: 2, spaceBetween: 16 },
          769: { slidesPerView: 3, spaceBetween: 20 },
          1025: { slidesPerView: 4, spaceBetween: 24 }
        }
      });
    });

    // Video gallery
    qsa('.video-gallery-swiper').forEach(function(el) {
      var slideCount = el.querySelectorAll('.swiper-slide').length;
      new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        freeMode: true,
        breakpoints: {
          480: { slidesPerView: 2.2, spaceBetween: 12 },
          769: { slidesPerView: Math.min(3, slideCount), spaceBetween: 16 },
          1025: { slidesPerView: Math.min(4, slideCount), spaceBetween: 16 }
        }
      });
    });
  }

  /* ---- Video Gallery Play/Pause ---- */
  function initVideoGallery() {
    qsa('[data-video-toggle]').forEach(function(btn) {
      on(btn, 'click', function(e) {
        e.preventDefault();
        var card = btn.closest('[data-video-card]');
        var video = qs('video', card);
        if (!video) return;
        if (video.paused) {
          video.play();
          card.classList.add('playing');
        } else {
          video.pause();
          card.classList.remove('playing');
        }
      });
    });
  }

  /* ---- Countdown Timer ---- */
  function initCountdown() {
    qsa('[data-countdown]').forEach(function(el) {
      var hoursLeft = parseInt(el.dataset.countdown) || 24;
      var endTime = Date.now() + hoursLeft * 60 * 60 * 1000;
      // Check localStorage for persistent end time
      var storageKey = 'ls_countdown_end';
      var stored = localStorage.getItem(storageKey);
      if (stored && parseInt(stored) > Date.now()) {
        endTime = parseInt(stored);
      } else {
        localStorage.setItem(storageKey, String(endTime));
      }

      function tick() {
        var diff = Math.max(0, endTime - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        el.innerHTML = '<span class="countdown-block">' + String(h).padStart(2, '0') + '</span>:' +
          '<span class="countdown-block">' + String(m).padStart(2, '0') + '</span>:' +
          '<span class="countdown-block">' + String(s).padStart(2, '0') + '</span>';
        if (diff > 0) requestAnimationFrame(function() { setTimeout(tick, 1000); });
      }
      tick();
    });
  }

  /* ---- Live Viewers ---- */
  function initLiveViewers() {
    qsa('[data-live-viewers]').forEach(function(el) {
      var min = parseInt(el.dataset.min) || 12;
      var max = parseInt(el.dataset.max) || 38;
      function update() {
        var count = Math.floor(Math.random() * (max - min + 1)) + min;
        el.textContent = count;
      }
      update();
      setInterval(update, 8000 + Math.random() * 4000);
    });
  }

  /* ---- Smooth Scroll Anchors ---- */
  function initSmoothScroll() {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var target = qs(link.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      var offset = (qs('.site-header') ? qs('.site-header').offsetHeight : 0) + 20;
      window.scrollTo({
        top: target.offsetTop - offset,
        behavior: 'smooth'
      });
    });
  }

  /* ---- Sticky ATC (mobile) ---- */
  function initStickyATC() {
    var sticky = qs('.sticky-atc');
    var hero = qs('.hero-product, .product-page');
    if (!sticky || !hero) return;
    var heroForm = qs('form[action*="/cart/add"]', hero);
    if (!heroForm) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sticky.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(heroForm);

    on(qs('.btn', sticky), 'click', function(e) {
      e.preventDefault();
      heroForm.dispatchEvent(new Event('submit', { bubbles: true }));
    });
  }

  /* ---- Cart Page Qty ---- */
  function initCartPage() {
    var cartForm = qs('form[action*="/cart"]');
    if (!cartForm || !qs('.cart-table', cartForm)) return;

    on(cartForm, 'click', function(e) {
      var btn = e.target.closest('.cart-table-qty button');
      if (!btn) return;
      var input = qs('input', btn.parentElement);
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'decrease') {
        input.value = Math.max(0, val - 1);
      } else {
        input.value = val + 1;
      }
      // Auto-submit after change
      clearTimeout(cartForm._debounce);
      cartForm._debounce = setTimeout(function() { cartForm.submit(); }, 600);
    });

    on(cartForm, 'click', function(e) {
      var rm = e.target.closest('.cart-table-remove');
      if (!rm) return;
      e.preventDefault();
      var input = rm.closest('tr').querySelector('.cart-table-qty input');
      if (input) { input.value = 0; cartForm.submit(); }
    });
  }

  /* ---- Collection Sort ---- */
  function initCollectionSort() {
    var sortSelect = qs('[data-sort-select]');
    if (!sortSelect) return;
    // Set current value from URL
    var params = new URLSearchParams(window.location.search);
    var currentSort = params.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;
    on(sortSelect, 'change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---- Init ---- */
  
  /* ---- Video posters (seek to first frame for preview) ---- */
  function initVideoPosters() {
    // Il primo fotogramma viene caricato solo quando il video entra nella parte visibile della pagina:
    // così i 4 video (1,3 MB) non rallentano l'immagine principale su mobile.
    var prepara = function(v) {
      if (v.dataset.posterInit) return;
      v.dataset.posterInit = '1';
      var seek = function() {
        try { if (v.duration && isFinite(v.duration)) v.currentTime = 0.1; } catch (e) {}
      };
      if (v.readyState >= 1) { seek(); return; }
      v.addEventListener('loadedmetadata', seek, { once: true });
      try { v.preload = 'metadata'; v.load(); } catch (e) {}
    };
    var vids = qsa('video');
    if (!('IntersectionObserver' in window)) { vids.forEach(prepara); return; }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) { if (en.isIntersecting) { prepara(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function(v) { io.observe(v); });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initVideoPosters();
    initHeader();
    initCartDrawer();
    initAddToCart();
    initQuantity();
    initGallery();
    initLightbox();
    initFAQ();
    initProductAccordion();
    initBeforeAfter();
    initReveal();
    initBackToTop();
    initSwipers();
    initVideoGallery();
    initCountdown();
    initLiveViewers();
    initSmoothScroll();
    initStickyATC();
    initCartPage();
    initCollectionSort();
  });

})();
